import { ConditionalOutputType } from "./ConditionalOutputType";

export class ConditionalOutput<T> {
  private readonly items: Array<ConditionalOutputType<T>> = [];
  private filterEmptyValues: boolean = true;
  private hasSetDefaultOrThrow: boolean = true;
  public constructor(
    ...initValues: Array<ConditionalOutputType<T>>
  ) {
    this.items.push(...initValues);
    this.hasSetDefaultOrThrow = initValues.length > 0;
  }
  public OnCondition(condition: boolean, ...additionalValues: Array<ConditionalOutputType<T>>): ConditionalOutput<T> {
    if (condition) {
      this.items.push(...additionalValues.filter(x => (!this.filterEmptyValues || typeof(x) === "boolean") || !!x));
    }
    return this;
  }
  public OnWindows(...additionalValues: Array<ConditionalOutputType<T>>): ConditionalOutput<T> {
    this.OnCondition(window.navigator.platform.indexOf("Win") > -1, ...additionalValues);
    return this;
  }
  public OnDocumentQuerySelectorExists(querySelection: string, ...additionalValues: Array<ConditionalOutputType<T>>): ConditionalOutput<T> {
    if (!querySelection) {
      throw new Error("querySelection should be a string");
    }
    if (document.querySelector(querySelection)) {
      this.items.push(...additionalValues.filter(x => (!this.filterEmptyValues || typeof(x) === "boolean") || !!x));
    }
    return this;
  }
  public DoNotFilterEmptyValues(): ConditionalOutput<T> {
    this.filterEmptyValues = false;
    return this;
  }
  public AsClassName(): string {
    this.throwOnNoDefaultChosen();
    
    return this.items
      .map(x => `${x}`)
      .reduce((x, y) => `${x} ${y}`, '');
  }
  public Last(): ConditionalOutputType<T> {
    this.throwOnNoDefaultChosen();
    if (!this.items.length) {
      throw new Error("Cannot get last of an empty list");
    }
    return this.items[this.items.length - 1];
  }
  public OnDefaultThrow(): ConditionalOutput<T> {
    if (this.hasSetDefaultOrThrow) {
      throw new Error("OnDefaultThrow cannot be used twice in a chain, neither users with default parameters.");
    }

    this.hasSetDefaultOrThrow = true;
    return this;
  }
  private throwOnNoDefaultChosen(): void {
    if (!this.hasSetDefaultOrThrow) {
      throw new Error("A default has not been chosen - either use OnDefaultThrow() to accept throwing when a value cannot be taken or provide one with ConditionalOutputFactory.WithDefault");
    }
  }
}
